import { serviceName } from '../resources/serviceConstants';

export const getBlogs = (years) => {
  // Check if years array is provided and not empty
  const yearQuery = years && years.length > 0
    ? years.map((year) => `year=${year}`).join('&') // Map each year to the query string format
    : ''; // If no years, leave the query string empty

  const url = yearQuery ? `/v1/blogs?${yearQuery}` : '/v1/blogs';

  return {
    url: url,
    method: 'get',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    service: serviceName.ACHIEVEMENTS_MS,
  };
};
